import * as React from 'react';

function SvgCalendarOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.42 3.525a.8.8 0 10-1.6 0v.622h-.622a2.933 2.933 0 00-2.932 2.932v12.796a2.933 2.933 0 002.932 2.933h14.218a2.933 2.933 0 002.932-2.933V7.079a2.933 2.933 0 00-2.932-2.932h-.622v-.622a.8.8 0 00-1.6 0v.622H7.42v-.622zm-.803 2.222H19.416c.736 0 1.332.596 1.332 1.332v.622H3.866V7.08c0-.736.597-1.332 1.332-1.332h1.419zM3.866 9.3v10.574c0 .736.597 1.332 1.332 1.332h14.218c.736 0 1.332-.596 1.332-1.332V9.3H3.866z", clipRule: "evenodd" })));
}

export default SvgCalendarOutline;
